import Swiper from '../../../node_modules/swiper/js/swiper';

export default function v1TopCarouselArea() {
  if (!document.getElementsByClassName('v1-top-carousel--area')) {
    return;
  }
  const mySwiper = new Swiper('.v1-top-carousel--area .swiper-container', {// eslint-disable-line
    speed: 500,
    loop: true,
    navigation: {
      nextEl: '.v1-top-carousel--area .swiper-button-next',
      prevEl: '.v1-top-carousel--area .swiper-button-prev',
    },
    // A11y http://idangero.us/swiper/api/#a11y
    // Autoplay http://idangero.us/swiper/api/#autoplay
    autoplay: false,
  });

  /**
   * マップにマウスオーバーすると、スライドも切り替わる
   */
  const areaGroup = document.querySelectorAll('[class*=v1-topPref-]');

  const isTouchDevice = window.ontouchstart === null;
  Array.from(areaGroup).forEach(area => {
    if (!isTouchDevice) {
      area.addEventListener('mouseover', e => {
        const areaName = e.target.closest('a').querySelector('tspan').textContent;
        // Mapのエリア名と合わせるために一文字目を大文字にする
        // const areaId = areaName.charAt(0).toUpperCase() + areaName.slice(1);
        const elm = document.getElementById(areaName);
        const slideItem = document.querySelectorAll('#v1-top-carouselArea .swiper-slide');

        const index = Array.prototype.indexOf.call(slideItem, elm);

        mySwiper.slideTo(index);
      });
    }
  });
}
